import React, { useContext } from "react";
import { CDN_BASE_URL } from "../../../config";
import { Link } from "react-router-dom";
import { ProductContext } from "../../../context/ProductContext";

const ProductCardDesc = ({
  data,
  select,
  setdata,
  handleClose,
  mainData,
  index,
  setselectedBrand,
}) => {
  const { name, img, category, url, _id, vehicle_number } = data;
  const { setselectProduct } = useContext(ProductContext);

  if (!select) {
    return (
      <Link
        to={`/${url?.category?.url}/${url?.brand?.name}/${url?.name}/${vehicle_number}`}
        className="border-brand grid grid-cols-12 overflow-hidden"
        title={`مشخصات محصول ${name}`}
      >
        <span className="col-span-12">
          {img?.img_webp ? (
            <picture>
              <source type="image/webp" srcset={CDN_BASE_URL + img?.img_webp} />
              <img
                src={CDN_BASE_URL + img?.img_jpg}
                alt={name}
                title={name}
                className="w-full  object-cover h-[180px]"
              />
            </picture>
          ) : img ? (
            <img
              src={CDN_BASE_URL + img}
              alt={name}
              title={name}
              className="w-full  object-cover h-[180px]"
            />
          ) : (
            <img
              src={"/no-image.jpg"}
              alt={name}
              title={name}
              className="w-full  object-cover h-[180px]"
            />
          )}
        </span>
        <span className="col-span-12 p-4 ">
          <h3 className="text-[16px] font-[600] text-center">
            {category?.name} {name}
          </h3>
        </span>
      </Link>
    );
  } else {
    return (
      <div
        onClick={() => {
          setdata((cur) => ({ ...cur, [index]: data }));
          handleClose();
          setselectedBrand(false);
        }}
        className="border-brand grid grid-cols-12 overflow-hidden cursor-pointer"
      >
        <span className="col-span-12">
          <img
            src={CDN_BASE_URL + img}
            alt={name}
            title={name}
            className="w-full  object-cover h-[150px]"
          />
        </span>
        <span className="col-span-12 p-4 ">
          <h3 className="text-[16px] font-[600] text-center">
            {category?.name} {name}
          </h3>
        </span>
      </div>
    );
  }
};

export default ProductCardDesc;
